import { render } from "./MainNavV2.vue?vue&type=template&id=10b5931d"
import script from "./MainNavV2.vue?vue&type=script&lang=js"
export * from "./MainNavV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__